export enum RedirectionCode {
    NoRedirection=1,
    RedirectWithURL=2
}
